import { render, staticRenderFns } from "./SalesInvoiceViewGlobal.vue?vue&type=template&id=108060c6"
import script from "./SalesInvoiceViewGlobal.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports